<template>
  <div class="orderMain">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="会员日志" name="eleven"> </el-tab-pane>
      <el-tab-pane label="会员成绩日志" name="twelve"> </el-tab-pane>
      <el-tab-pane label="会员比赛日志" name="thirteen">
        <div class="title_div">
          <span class="title-span">比赛：</span>
          <el-select
            clearable
            size="small"
            v-model="PKParams.gameId"
            placeholder="请选择比赛"
            @change="searchGameId"
          >
            <el-option
              v-for="item in PKListSelect"
              :key="item.id"
              :label="item.gameName"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <span class="title-span">比赛：</span>
          <el-input
            size="small"
            style="width: 200px; margin-top: 20px"
            v-model="PKParams.gameName"
            placeholder="请输入比赛名称"
            clearable
            @input="searchGameIdValue"
          ></el-input>
          <span class="title-span">会员：</span>
          <el-input
            size="small"
            style="width: 200px; margin-top: 20px"
            v-model="PKParams.queryValue"
            placeholder="会员电话、姓名"
            clearable
            @input="searchMember"
          ></el-input>
          <br />
          <div style="margin-top: 10px">
            <span class="title-span">创建时间：</span>
            <el-date-picker
              @change="dateChange"
              v-model="PKParams.dateStart"
              size="small"
              class="title-date1"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择开始日期"
            >
            </el-date-picker>
            至
            <el-date-picker
              @change="dateChange"
              v-model="PKParams.dateEnd"
              size="small"
              class="title-date2"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择结束日期"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="mm-tb">
          <el-table :data="PKList" style="width: 100%">
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="50"
            >
            </el-table-column>
            <el-table-column prop="memberName" label="会员名称" align="center">
              <template slot-scope="scope">
                <div
                  @click="seeRb(scope.row.allPhotoPath)"
                  style="color: #409eff"
                >
                  {{ scope.row.memberName ? scope.row.memberName : "" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="memberName" label="会员电话" align="center">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.memberMobile ? scope.row.memberMobile : "" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="createDate" label="操作时间" align="center">
            </el-table-column>
            <el-table-column
              prop="createUserName"
              label="操作人"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="gameName" label="赛事名称" align="center">
            </el-table-column>
            <el-table-column
              prop="gameDateStart"
              label="赛事开始时间"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="gameDateEnd"
              label="赛事结束时间"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="bowTypeText" label="弓种" align="center">
            </el-table-column>
            <el-table-column prop="meterType_text" label="米数" align="center">
            </el-table-column>
            <el-table-column
              prop="targetSheet_text"
              label="靶纸"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="groupArrow_text"
              label="每组箭支"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="groupCountType_text"
              label="组数"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="totalScore" label="总成绩" align="center">
            </el-table-column>
            <el-table-column prop="score" label="成绩" align="center">
            </el-table-column>
            <el-table-column prop="shopName" label="门店" align="center">
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            class="mm-page"
             @size-change="SizeChange"
            @current-change="PKCurrentChange"
            :current-page="PKResult.current"
            :page-size="PKResult.size"
            layout="total,prev, pager, next, sizes"
            :total="PKResult.total"
             :page-sizes="[10, 20, 30, 40, 50]"
          >
          </el-pagination></div
      ></el-tab-pane>
      <el-tab-pane label="日榜" name="six"> </el-tab-pane>
      <el-tab-pane label="组数王" name="seven"> </el-tab-pane>
      <el-tab-pane label="资讯管理" name="one"> </el-tab-pane>
      <el-tab-pane label="活动管理" name="two"> </el-tab-pane>
      <el-tab-pane label="活动报名" name="three"> </el-tab-pane>
      <el-tab-pane label="赛事管理" name="four"> </el-tab-pane>
      <el-tab-pane label="日榜管理" name="five"> </el-tab-pane>

      <el-tab-pane label="段位管理" name="eight"> </el-tab-pane>
      <el-tab-pane label="勋章管理" name="nine"> </el-tab-pane>
      <el-tab-pane label="订单项管理" name="ten"></el-tab-pane>
    </el-tabs>
    <el-dialog
      title="查看图片"
      :visible.sync="photoDialogVisible"
      width="700px"
      style="text-align: center"
      :close-on-click-modal="false"
    >
      <el-image
        v-for="(item, index) in this.photoList"
        lazy
        style="width: 200px; height: 200px; margin: 10px"
        :src="item"
        :key="index"
        :preview-src-list="photoList"
      >
      </el-image>
    </el-dialog>
  </div>
</template>

<script>
import {
  getGamePageList,
  getGameScorePage,
} from "../../api/OperationManagement";
import { globelurl } from "../../api/axios.js";
export default {
  name: "13MedalManagement",
  data() {
    return {
      activeName: "thirteen",
      PKList: [],
      PKResult: {},
      PKListSelect: [],
      PKParams: {
        pageNo: 1,
        pageSize: 10,
        gameId: "",
        gameName: "",
        dateStart: "",
        dateEnd: "",
        queryValue: "",
      },
      photoList: [],
      titleUrl: globelurl,
      photoDialogVisible: false,
    };
  },
  created() {},
  mounted() {
    this.getGameScorePage(this.PKParams);
    this.getGamePageList();
  },
  methods: {
    handleClick(tab, event) {
      if (tab.label == "资讯管理") {
        this.$router.push("/OperationManagement/1InformationManagement");
      } else if (tab.label == "活动管理") {
        this.$router.push("/OperationManagement/2ActivityManagement");
      } else if (tab.label == "活动报名") {
        this.$router.push("/OperationManagement/3ActivityRegistration");
      } else if (tab.label == "赛事管理") {
        this.$router.push("/OperationManagement/4EventManagement");
      } else if (tab.label == "日榜管理") {
        this.$router.push("/OperationManagement/5RankingList");
      } else if (tab.label == "日榜") {
        this.$router.push("/OperationManagement/6ListManagement");
      } else if (tab.label == "组数王") {
        this.$router.push("/OperationManagement/7GroupNumberList");
      } else if (tab.label == "段位管理") {
        this.$router.push("/OperationManagement/8RankManagement");
      } else if (tab.label == "勋章管理") {
        this.$router.push("/OperationManagement/9MedalManagement");
      } else if (tab.label == "订单项管理") {
        this.$router.push("/OperationManagement/10MedalManagement");
      } else if (tab.label == "会员日志") {
        this.$router.push("/OperationManagement/11MedalManagement");
      } else if (tab.label == "会员成绩日志") {
        this.$router.push("/OperationManagement/12MedalManagement");
      } else if (tab.label == "会员比赛日志") {
        // this.$router.push("/OperationManagement/13MedalManagement");
      }
    },

    getGameScorePage(params) {
      getGameScorePage(params).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.PKResult = res.data.result;
            this.PKList = res.data.result.records;
          } else {
            this.PKResult = res.data.result;
            this.PKList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //获取赛事列表
    getGamePageList() {
      getGamePageList({
        pageNo: 1,
        pageSize: 100,
      }).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.PKListSelect = res.data.result.records;
          } else {
            this.PKListSelect = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    SizeChange(newSize) {
      this.PKParams.pageSize = newSize;
      this.getGameScorePage(this.PKParams);
    },
    PKCurrentChange(newPage) {
      this.PKParams.pageNo = newPage;
      this.getGameScorePage(this.PKParams);
    },
    // 比赛下拉修改
    searchGameId() {
      this.PKParams.pageNo = 1;
      this.getGameScorePage(this.PKParams);
    },
    // 比赛輸入框修改
    searchGameIdValue() {
      this.PKParams.pageNo = 1;
      this.getGameScorePage(this.PKParams);
    },
    // 会员电话輸入框修改
    searchMember() {
      this.PKParams.pageNo = 1;
      this.getGameScorePage(this.PKParams);
    },
    // 时间修改
    dateChange() {
      if (
        this.PKParams.dateStart &&
        this.PKParams.dateEnd &&
        new Date(this.PKParams.dateStart).getTime() >
          new Date(this.PKParams.dateEnd).getTime()
      ) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.PKParams.pageNo = 1;
      this.getGameScorePage(this.PKParams);
    },
    //查看图片列表
    seeRb(photo) {
      const imgList = photo.split(",");
      this.photoList = [];
      imgList.forEach((itm) => {
        this.photoList.push(this.titleUrl + itm);
      });

      this.photoDialogVisible = true;
    },
  },
};
</script>
<style scoped>
.title-span {
  font-size: 16px;
  margin-left: 30px;
}

.orderMain {
  padding: 30px;
}

.title_div {
  margin: 20px 30px;
}

.title-select {
  margin: 0 20px;
  width: 200px;
}

.title-date1 {
  width: 180px;
}

.title-date2 {
  width: 180px;
}

.creat-button {
  margin: 20px 80px;
}

.mm-tb {
  width: 90%;
  margin-left: 50px;
}

.mm-page {
  margin: 30px 60px;
}
</style>